import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { lineGroupQueries } from '@/services/premiumStores/lineGroup/lineGroup.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useLineGroupMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation('manageLineDetails', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: lineGroupQueries.all() });
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};
